import axios from "axios";

import type { Block, Step, StepType } from "@virtual-brain-lib/types";

import env from "../environments";

export async function createStep({
	applicationId,
	name,
	type,
	index,
	skippable,
	description,
	optionList,
}: {
	applicationId: string;
	name: string;
	type: StepType;
	index: number;
	skippable: boolean;
	description?: string;
	optionList?: string[];
}) {
	const response = await axios.post<{ step: Step }>(`${env.apiUrl}/steps`, {
		applicationId,
		name,
		type,
		index,
		description,
		skippable,
		optionList,
	});

	return response.data.step;
}

export async function updateStep(step: Partial<Step>) {
	const response = await axios.put<{ step: Step }>(`${env.apiUrl}/steps/${step.id}`, step);

	return response.data.step;
}

export async function updateStepOrder({ stepIds }: { stepIds: string[] }) {
	const response = await axios.patch<Step[]>(`${env.apiUrl}/steps/reorder`, {
		stepIds,
	});

	return response.data;
}

export async function deleteStep(stepId: string) {
	const response = await axios.delete<{ updatedBlocks: Block[] }>(
		`${env.apiUrl}/steps/${stepId}`,
	);

	return response.data;
}
